import $ from "zeptojs";
import findCaseInsensitiveAttributeName from "utils/findCaseInsensitiveAttributeName";
import stripSvgDataPrefix from "utils/stripSvgDataPrefix";
import xmlToString from "utils/xmlToString";

export default function addViewboxToSvg(svg) {
  svg = stripSvgDataPrefix(svg);
  const parser = new DOMParser();
  const xmlNode = parser.parseFromString(svg, "text/xml");
  const $xml = $(xmlNode);
  const $svg = $($xml.find("svg").get(0));

  const viewboxKey = findCaseInsensitiveAttributeName($svg.get(0), "viewbox");

  const viewbox = $svg.attr(viewboxKey);

  if (!viewbox) {
    const height = parseFloat($svg.attr("height"));
    const width = parseFloat($svg.attr("width"));
    $svg.attr("viewBox", `0 0 ${width} ${height}`);
    return xmlToString($xml.get(0));
  }

  return svg;
}
